import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { MyDomain } from "./App";

export default function AddProduct() {
  const { t, i18n } = useTranslation();
  // Products values
  const [Name, setName] = useState("");
  const [Image, setImage] = useState("");
  const [Price, setPrice] = useState("");
  const [Discount, setDiscount] = useState(""); //Empty
  const [Category, setCategory] = useState("");
  const [NumberUsersRating, setNumberUsersRating] = useState(""); //Empty
  const [Rating, setRating] = useState(""); //Empty
  const [InWishList, setInWishList] = useState(""); //Empty // maybe i will delete that !
  const [Deals, setDeals] = useState("");
  const [DiscId, setDiscId] = useState(""); //Id of the Product
  const [InStock, setInStock] = useState("");

  // ProductFilter values
  const [Brand, setBrand] = useState("");
  const [ProductType, setProductType] = useState("");
  const [Classfication, setClassfication] = useState("");
  const [ProductProperties, setProductProperties] = useState("");
  const [Color, setColor] = useState("");
  const [Gender, setGender] = useState("");
  const [Age, setAge] = useState("");
  const [ScentType, setScentType] = useState("");
  const [TopNote, setTopNote] = useState("");
  const [HeartNote, setHeartNote] = useState("");
  const [BaseNote, setBaseNote] = useState("");
  const [Ingredients, setIngredients] = useState("");
  const [SpecialCertificates, setSpecialCertificates] = useState("");
  const [Country, setCountry] = useState("");
  const [Volume, setVolume] = useState("");
  const [MadeIn, setMadeIn] = useState("");
  const [PriceFilter, setPriceFilter] = useState("");

  // ProductDisc values
  const [Characteristics, setCharacteristics] = useState("");
  const [Discreption, setDiscreption] = useState("");
  const [HowToUse, setHowToUse] = useState("");

  const CreateProduct = (event) => {
    //event.preventDefault();
    const data = {
      product: {
        name: "12 Perfume Product",
        image:
          "https://mybarberblob.blob.core.windows.net/makeupproductspics/Luxuryperfume3.png",
        price: "59.99",
        discount: "Discount",
        category: "Perfume",
        numberUsersRating: "100",
        rating: "4.5",
        inWishList: "Yes",
        deals: "Deal",
        //discId: "12345",
        inStock: "Yes",
      },
      productFilter: {
        brand: "Brand Name",
        productType: "Type",
        classfication: "Classification",
        productProperties: "Properties",
        color: "Color",
        gender: "Unisex",
        age: "18",
        scentType: "Floral",
        topNote: "Top Note",
        heartNote: "Heart Note",
        baseNote: "Base Note",
        ingredients: "Ingredients",
        specialCertificates: "Certificates",
        country: "Country",
        volume: "Volume",
        madeIn: "Italy",
        price: "Price",
      },
      productDisc: {
        characteristics: "Characteristics",
        discreption: "Description",
        howToUse: "Instructions",
      },
    };

    axios
      .post(`${MyDomain}Products/CreateProductWithDetails`, data) // replace with your API URL
      .then((response) => {
        //setResponseMessage("Data submitted successfully!");
        console.log(response.data);
      })
      .catch((error) => {
        //setResponseMessage("Error submitting data.");
        console.log(error);
      });
  };
  return (
    <div>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-evenly",
          paddingTop: 50,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "32%",
          }}
        >
          <p style={{ fontWeight: "bold" }}>Product</p>
          <TextField
            id="standard-basic"
            label="Product name"
            variant="standard"
            style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={Name} // Bind the state value to the TextField
            onChange={(e) => setName(e.target.value)} // Update state on input change
          />
          <TextField
            id="standard-basic"
            label="Image"
            variant="standard"
            style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={Image} // Bind the state value to the TextField
            onChange={(e) => setImage(e.target.value)} // Update state on input change
          />
          <TextField
            id="standard-basic"
            label="Price"
            variant="standard"
            style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={Price} // Bind the state value to the TextField
            onChange={(e) => setPrice(e.target.value)} // Update state on input change
          />
          <TextField
            id="standard-basic"
            label="Discount"
            variant="standard"
            style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={Discount} // Bind the state value to the TextField
            onChange={(e) => setDiscount(e.target.value)} // Update state on input change
          />

          <TextField
            id="standard-basic"
            label="Category"
            variant="standard"
            style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={Category} // Bind the state value to the TextField
            onChange={(e) => setCategory(e.target.value)} // Update state on input change
          />
          <TextField
            id="standard-basic"
            label="NumberUsersRating"
            variant="standard"
            style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={NumberUsersRating} // Bind the state value to the TextField
            onChange={(e) => setNumberUsersRating(e.target.value)} // Update state on input change
          />
          <TextField
            id="standard-basic"
            label="Rating"
            variant="standard"
            style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={Rating} // Bind the state value to the TextField
            onChange={(e) => setRating(e.target.value)} // Update state on input change
          />
          <TextField
            id="standard-basic"
            label="InWishList"
            variant="standard"
            style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={InWishList} // Bind the state value to the TextField
            onChange={(e) => setInWishList(e.target.value)} // Update state on input change
          />
          <TextField
            id="standard-basic"
            label="Deals"
            variant="standard"
            style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={Deals} // Bind the state value to the TextField
            onChange={(e) => setDeals(e.target.value)} // Update state on input change
          />
          <TextField
            id="standard-basic"
            label="DiscId"
            variant="standard"
            style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={DiscId} // Bind the state value to the TextField
            onChange={(e) => setDiscId(e.target.value)} // Update state on input change
          />
          <TextField
            id="standard-basic"
            label="InStock"
            variant="standard"
            style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={InStock} // Bind the state value to the TextField
            onChange={(e) => setInStock(e.target.value)} // Update state on input change
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "32%",
          }}
        >
          <p style={{ fontWeight: "bold" }}>Product Filter</p>
          <TextField
            id="standard-basic"
            label="Brand"
            variant="standard"
            style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={Brand} // Bind the state value to the TextField
            onChange={(e) => setBrand(e.target.value)} // Update state on input change
          />
          <TextField
            id="standard-basic"
            label="Product Type"
            variant="standard"
            style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={ProductType} // Bind the state value to the TextField
            onChange={(e) => setProductType(e.target.value)} // Update state on input change
          />

          <TextField
            id="standard-basic"
            label="Classfication"
            variant="standard"
            style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={Classfication} // Bind the state value to the TextField
            onChange={(e) => setClassfication(e.target.value)} // Update state on input change
          />

          <TextField
            id="standard-basic"
            label="ProductProperties"
            variant="standard"
            style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={ProductProperties} // Bind the state value to the TextField
            onChange={(e) => setProductProperties(e.target.value)} // Update state on input change
          />
          <TextField
            id="standard-basic"
            label="Color"
            variant="standard"
            style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={Color} // Bind the state value to the TextField
            onChange={(e) => setColor(e.target.value)} // Update state on input change
          />
          <TextField
            id="standard-basic"
            label="Gender"
            variant="standard"
            style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={Gender} // Bind the state value to the TextField
            onChange={(e) => setGender(e.target.value)} // Update state on input change
          />
          <TextField
            id="standard-basic"
            label="Age"
            variant="standard"
            style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={Age} // Bind the state value to the TextField
            onChange={(e) => setAge(e.target.value)} // Update state on input change
          />

          <TextField
            id="standard-basic"
            label="Scent Type"
            variant="standard"
            style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={ScentType} // Bind the state value to the TextField
            onChange={(e) => setScentType(e.target.value)} // Update state on input change
          />
          <TextField
            id="standard-basic"
            label="Top Note"
            variant="standard"
            style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={TopNote} // Bind the state value to the TextField
            onChange={(e) => setTopNote(e.target.value)} // Update state on input change
          />
          <TextField
            id="standard-basic"
            label="Heart Note"
            variant="standard"
            style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={HeartNote} // Bind the state value to the TextField
            onChange={(e) => setHeartNote(e.target.value)} // Update state on input change
          />
          <TextField
            id="standard-basic"
            label="Base Note"
            variant="standard"
            style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={BaseNote} // Bind the state value to the TextField
            onChange={(e) => setBaseNote(e.target.value)} // Update state on input change
          />

          <TextField
            id="standard-basic"
            label="Ingredients"
            variant="standard"
            style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={Ingredients} // Bind the state value to the TextField
            onChange={(e) => setIngredients(e.target.value)} // Update state on input change
          />
          <TextField
            id="standard-basic"
            label="SpecialCertificates"
            variant="standard"
            style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={SpecialCertificates} // Bind the state value to the TextField
            onChange={(e) => setSpecialCertificates(e.target.value)} // Update state on input change
          />
          <TextField
            id="standard-basic"
            label="Country"
            variant="standard"
            style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={Country} // Bind the state value to the TextField
            onChange={(e) => setCountry(e.target.value)} // Update state on input change
          />
          <TextField
            id="standard-basic"
            label="Volume"
            variant="standard"
            style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={Volume} // Bind the state value to the TextField
            onChange={(e) => setVolume(e.target.value)} // Update state on input change
          />
          <TextField
            id="standard-basic"
            label="MadeIn"
            variant="standard"
            style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={MadeIn} // Bind the state value to the TextField
            onChange={(e) => setMadeIn(e.target.value)} // Update state on input change
          />

          <TextField
            id="standard-basic"
            label="Price"
            variant="standard"
            style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={PriceFilter} // Bind the state value to the TextField
            onChange={(e) => setPriceFilter(e.target.value)} // Update state on input change
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "32%",
          }}
        >
          <p style={{ fontWeight: "bold" }}>Product Disc</p>
          <TextField
            id="standard-basic"
            label="Characteristics"
            variant="standard"
            style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={Characteristics} // Bind the state value to the TextField
            onChange={(e) => setCharacteristics(e.target.value)} // Update state on input change
          />{" "}
          <TextField
            id="standard-basic"
            label="Discreption"
            variant="standard"
            style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={Discreption} // Bind the state value to the TextField
            onChange={(e) => setDiscreption(e.target.value)} // Update state on input change
          />
          <TextField
            id="standard-basic"
            label="HowToUse"
            variant="standard"
            style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={HowToUse} // Bind the state value to the TextField
            onChange={(e) => setHowToUse(e.target.value)} // Update state on input change
          />
          <div
            style={{
              width: "100%",
              maxWidth: 500,
              justifyContent: "center",
              display: "flex",
            }}
          >
            <button
              style={{
                backgroundColor: "white",
                borderWidth: 1,
                padding: 20,
                width: 200,
              }}
              onClick={() => {
                CreateProduct();
              }}
            >
              Create
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
